import { booleanDataset, hasBooleanDataset } from './utils.js';

class FormWrapper extends HTMLElement {
  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve));
    this.#revealItems();
  }

  #revealItems() {
    const items = this.querySelectorAll('.ui-reveal');

    const observer = new IntersectionObserver((entries) => {
      entries
        .filter(entry => entry.isIntersecting && !hasBooleanDataset(entry.target, 'reveal'))
        .forEach(entry => {
          setTimeout(() => booleanDataset(entry.target, 'reveal', true), 150);
        });
    });

    if (items?.length) {
      items.forEach(item => observer.observe(item));
    }
  }
}

customElements.define('form-wrapper', FormWrapper);
